// frontend/src/components/concierge/tabs/ProfileCard.jsx
// Profile completeness checklist, shown on both the Overview and Details tabs.
// Fetches its own data so either tab can drop it in without plumbing.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';

export default function ProfileCard({ userId, onEditProfile }) {
  const { API_URL } = useAuth();
  const [items, setItems] = useState(null);
  const [itemsErr, setItemsErr] = useState('');

  useEffect(() => {
    const cfg = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    axios.get(`${API_URL}/concierge/${userId}/completeness`, cfg)
      .then(res => setItems(Array.isArray(res.data?.items) ? res.data.items : []))
      .catch(() => { setItems(null); setItemsErr('Failed to load profile completeness.'); });
  }, [userId, API_URL]);

  const done = (items || []).filter(i => i.done).length;
  const total = (items || []).length;
  const pct = total ? Math.round((done / total) * 100) : 0;

  return (
    <section className="cn-card">
      <div className="cn-card__head">
        <h2 className="cn-card__title">Profile</h2>
        {items && <span className="cn-card__sub">{done} of {total} complete · {total - done} missing</span>}
        {onEditProfile && <button type="button" className="cn-card__action" onClick={onEditProfile}>Edit profile →</button>}
      </div>
      {itemsErr && <div className="cn-card__err">{itemsErr}</div>}
      {itemsErr ? null : items === null ? <div className="cn-loading">Loading…</div> : (
        <div className="cn-complete">
          <div className="cn-progress" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
            <span style={{ width: `${pct}%` }} />
          </div>
          <div className="cn-checklist">
            {items.map(i => (
              <div key={i.key} className={`cn-check2${i.done ? '' : ' cn-check2--missing'}`} data-done={String(i.done)}>
                <span className="cn-check2__dot" aria-hidden="true">{i.done ? '✓' : '!'}</span>
                <div><div className="cn-check2__title">{i.label}</div><div className="cn-check2__sub">{i.sub}</div></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
